<template>
  <div class="employment">
    <div class="base-search">
      <el-button
        type="success"
        icon="el-icon-plus"
        @click="addEvent"
        style="background: #623aa2; border: none"
      >
        新增
      </el-button>
      <el-button type="danger" icon="el-icon-delete" @click="deleteAll">批量删除</el-button>
      <el-input
        placeholder="请输入内容"
        v-model="listQuery.keyword"
        class="input-with-select"
        @keyup.enter.native="search"
        clearable
        @clear="search"
        style="width: 240px"
      >
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
    </div>
    <div class="base-table">
      <el-table
        ref="multipleTable"
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
        class="table"
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>

        <el-table-column
          type="index"
          :index="
            index => {
              return index + (listQuery.page - 1) * listQuery.pageSize + 1;
            }
          "
          label="序号"
          align="center"
        ></el-table-column>
        <el-table-column label="平台名称" align="center" prop="name"></el-table-column>
        <el-table-column
          label="平台类别"
          align="center"
          prop="platformCategoryName"
        ></el-table-column>
        <el-table-column label="服务对象" align="center" prop="serviceObjectName"></el-table-column>
        <el-table-column
          label="平台简介"
          align="center"
          prop="platformIntroduction"
          min-width="100"
        >
          <template slot-scope="{ row }">
            <div
              style="overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;"
            >
              {{ getSimpleText(row.platformIntroduction) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="平台级别" align="center" prop="platformLevel"></el-table-column>
        <el-table-column label="备注" align="center" prop="remark"></el-table-column>

        <el-table-column width="240px" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              class="mini_btn"
              size="mini"
              type="primary"
              @click="handleEdit(scope.$index, scope.row)"
            >
              编辑
            </el-button>
            <el-button
              class="mini_btn"
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      @current-change="handleCurrentChange"
      layout="total, prev, pager, next,jumper"
      :total="total"
      :current-page.sync="listQuery.page"
      style="text-align:left;margin:20px 0"
      :page-size="listQuery.pageSize"
    ></el-pagination>
    <el-dialog
      :title="Title"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      v-if="dialogFormVisible"
    >
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="120px">
        <el-row>
          <el-row>
            <el-form-item label="平台名称" prop="name">
              <el-input v-model="ruleForm.name" placeholder="请输入平台名称"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="平台类别" prop="platformCategoryId">
              <el-select
                style="width: 100%"
                v-model="ruleForm.platformCategoryId"
                placeholder="请选择"
                @change="changeTalent"
              >
                <el-option
                  v-for="item in rencaiList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="服务对象" prop="serviceObjectId">
              <el-select
                style="width: 100%"
                @change="changeTechFieldId"
                v-model="ruleForm.serviceObjectId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in jishuList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="所属地区" prop="postalAddressDistinguish">
              <el-select
                style="width: 100%"
                v-model="ruleForm.postalAddressDistinguish"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in areaList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="平台级别" prop="platformLevel">
              <el-input v-model="ruleForm.platformLevel" placeholder="请输入平台级别"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="备注" prop="remark">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入备注"
                v-model="ruleForm.remark"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="平台简介" prop="platformIntroduction">
              <editor
                refName="introduction"
                :placeholderText="'请填写平台简介'"
                v-model="ruleForm.platformIntroduction"
                :upload-url="uploadURL"
                :img-show-url="imgUrl"
              ></editor>
            </el-form-item>
          </el-row>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeForm('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" v-show="dialogType === 'add'">
          确 定
        </el-button>
        <el-button
          type="primary"
          @click="updateSubmitForm('ruleForm')"
          v-show="dialogType === 'edit'"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import { areaList } from './components/options'
import editor from "../../../components/tinymce-editor/tinymce-editor";

export default {
  components: {
		editor
	},
  data() {
    return {
      dialogType: '',
      listQuery: {
        keyword: '',
        is_page: 0,
        page: 1,
        pageSize: 10
      },
      deleteRow: [],
      rencaiList: [],
      jishuList: [],
      areaList: areaList,
      total: 10,
      Title: "",
      searchValue: "",
      dialogFormVisible: false,
      dialogVisible: false,
      tableData: [],
      ruleForm: {
        name: '',
        postalAddressDistinguish: '',
        platformCategoryId: '',
        platformCategoryName: '',
        serviceObjectId: '',
        serviceObjectName: '',
        platformIntroduction: '',
        platformLevel: '',
        remark: ''
      },
      rules: {
        name: [
          { required: true, message: "请输入平台名称", trigger: "blur" }
        ],
        postalAddressDistinguish: [
          { required: true, message: "请输入所属地区", trigger: "blur" }
        ],
        platformCategoryId: [
          { required: true, message: "请选择平台类别", trigger: "change" }
        ],
        serviceObjectId: [
          { required: true, message: "请选择服务对象", trigger: "change" }
        ],
        platformLevel: [
          { required: true, message: "请输入平台级别", trigger: "blur" }
        ],
        platformIntroduction: [
          { required: true, message: "请输入平台简介", trigger: "blur" }
        ]
      },
    };
  },
  created() {
    this.getSiftList('resource_platform_category', 'resource_engaged_field')
    this.getData();
  },
  methods: {
    getSimpleText(html){
      var re1 = new RegExp("<.+?>","g");//匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      var msg = html.replace(re1,'');//执行替换成空字符
      return msg;
    },
     // 人才类别和从事技术领域
     getSiftList(type1, type2) {
      this.http.post(`${this.urlConfig.devUrl}apij2/admin-api/system/dict-data/getGroup`, {
        dictTypes: [type1, type2]
      }).then(res => {
        if (res.code === 0) {
          const {resource_platform_category, resource_engaged_field} = res.data;
          this.rencaiList = [
              ...resource_platform_category
            ]

          this.jishuList = [
              ...resource_engaged_field
            ]
        }
      })
    },
    getData() {
    	this.http.post(this.urlConfig.devUrl+'apij2/admin-api/voucher/resource-innovation-platform/page',this.listQuery).then(res =>{
				if (res.code == 0) {
					this.tableData = res.data.data;
					this.total = res.data.total;
				}
			})
    },
    //新增
    addEvent() {
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
      }
      this.dialogFormVisible = true;
      this.Title = "新增";
      this.dialogType = 'add'

      this.ruleForm = {
        name: '',
        postalAddressDistinguish: '',
        businessCategoryId: '',
        businessCategoryName: '',
        engagedFieldId: '',
        engagedFieldName: '',
        companyProfile: '',
        patent: '',
        remark: ''
      };
    },
    	//选择页码
			handleCurrentChange(e) {
				this.listQuery.page = e;
				this.getData();
			},
  		//批量删除
    deleteAll() {
			if (this.deleteRow.length) {
				this.$confirm("此操作将批量删除, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
						center: true,
					})
					.then(() => {
						this.http
            .request(this.urlConfig.devUrl + "apij2/admin-api/voucher/resource-innovation-platform/delete", {
              ids: this.deleteRow
            }, "delete")
            .then((res) => {
              if (res.code == 0) {
                this.listQuery.page = 1;
                this.getData();
                this.$message({
                  type: "success",
                  message: "删除成功",
                });

              } else {
                this.$message({
                  message: "失败！",
                  type: "error",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });

			} else {
        this.$message({
					type: "warning",
					message: "请选择删除的记录",
				});
      }
		},
    //搜索
    search() {
      this.listQuery.page = 1;
      this.getData();
    },
    //选择
    selectionChange(selection) {
      this.deleteRow = [];
      if (selection.length != 0) {
        let arr = [];
        selection.forEach((item) => {
          arr.push(item.id);
        });
        this.deleteRow = arr;
      }
    },
    //编辑
    handleEdit(index, row) {
      this.dialogFormVisible = true;
      this.Title = "编辑";
      this.ruleForm = JSON.parse(JSON.stringify(row));
      this.dialogType = 'edit'
    },
    //删除
    handleDelete(index, row) {
      const data = [
        row.id
      ]
      this.$confirm("此操作将批量删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.http
            .request(this.urlConfig.devUrl + "apij2/admin-api/voucher/resource-innovation-platform/delete", {
              ids: data
            }, "delete")
            .then((res) => {
              if (res.code == 0) {
                this.listQuery.page = 1;
                this.getData();
                this.$message({
                  type: "success",
                  message: "删除成功",
                });

              } else {
                this.$message({
                  message: "失败！",
                  type: "error",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //取消
    closeForm(name) {
      this.dialogFormVisible = false;
      this.$refs[name].resetFields();
    },
    // 人才
    changeTalent(id) {
      console.log('id')
      const data = this.rencaiList.find(item => item.id == id);
      this.ruleForm.platformCategoryName = data.label;
    },
    // 技术领域
    changeTechFieldId(id) {
      const data = this.jishuList.find(item => item.id == id);
      this.ruleForm.serviceObjectName = data.label;
    },
    addData() {
      this.http.post(`${this.urlConfig.devUrl}apij2/admin-api/voucher/resource-innovation-platform/create`, this.ruleForm).then(res => {
        if (res.code === 0) {
          this.getData()
          this.dialogFormVisible = false;
          this.$message.success('新增成功');
        } else {
          this.$messgae.error('新增失败')
        }
      }).catch(e => {
        this.$messgae.error('新增失败')
      })
    },
    editData() {
      this.http.put(`${this.urlConfig.devUrl}apij2/admin-api/voucher/resource-innovation-platform/update`, this.ruleForm).then(res => {
        if (res.code === 0) {
          this.getData()
          this.dialogFormVisible = false;
          this.$message.success('编辑成功');
        } else {
          this.$messgae.error('编辑失败')
        }
      }).catch(e => {
        this.$messgae.error('编辑失败')
      })
    },
    //提交
    submitForm(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          // 新增提交
          this.addData()
        } else {
          return false;
        }
      });
    },
    updateSubmitForm(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          // 编辑提交
          this.editData()
        } else {
          return false;
        }
      });
    }
  },
};
</script>

<style scoped lang="scss">
.employment {
  height: 100%;
  width: 100%;
  .base-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    /deep/.el-input--suffix {
      width: 100%;
      margin: 0 15px;
    }
    .el-input {
      // width: 400px;
      margin: 0 15px;
    }
    .date-picker {
      margin: 0 15px;
      .el-range-separator {
        width: auto;
      }
    }
  }
  .base-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;
  }
}
/*上传图片*/
.is_border {
  border: 1px dashed #ddd !important;
  border-radius: 5px;
  height: 154px !important;
  line-height: 154px !important;
}

.upload_btn {
  display: block;
  background-color: #00a1ff;
  font-weight: bold;
  color: #fff;
  padding: 2px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}

.upload_btn:hover {
  background-color: #13ce66;
}

.del_img {
  position: absolute;
  top: -7px;
  left: 224px;
  color: #00a1ff;
}

.del_img:hover {
  cursor: pointer;
  color: #f00;
}

.del_img i:before {
  font-size: 20px;
}

.img_border {
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  width: 243px;
  height: 154px;
  display: block;
}

.avatar-uploader {
  text-align: center;
  width: 243px;
  height: 198px;
}

/deep/ .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .el-upload:hover {
  border-color: #409eff !important;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 243px;
  height: 154px;
  line-height: 154px;
  text-align: center;
}
</style>
